import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enTranslations from "./locales/en.json";
import zhTranslations from "./locales/zh.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		lng: "zh",
		resources: {
			en: {
				translation: enTranslations,
			},
			zh: {
				translation: zhTranslations,
			},
		},
		fallbackLng: "en",
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ["querystring", "localStorage", "navigator"],
			lookupQuerystring: "lng",
			lookupLocalStorage: "i18nextLng",
			caches: ["localStorage"],
		},
	});

export default i18n;
